/**
 * Voz fixa para leitura dos textos de ajuda (ⓘ): Luciana (pt-BR).
 * Sem opção de troca no app ou na plataforma.
 */
export const HELP_TTS_LANG = "pt-BR";

/** Velocidade — um pouco abaixo de 1 soa mais natural na narração. */
export const HELP_TTS_RATE = 0.92;

/** Luciana primeiro; depois qualquer voz pt-BR como reserva. */
export const LOCKED_WEB_VOICE_MATCHERS = [/Luciana/i];

export function isPortugueseVoice(voice) {
  return (voice.lang || "").toLowerCase().startsWith("pt");
}

export function pickLockedWebVoice(voices) {
  const portugueseVoices = voices.filter(isPortugueseVoice);
  if (portugueseVoices.length === 0) return null;

  for (const pattern of LOCKED_WEB_VOICE_MATCHERS) {
    const match = portugueseVoices.find((voice) => pattern.test(voice.name));
    if (match) return match;
  }

  const brazilian = portugueseVoices.find((voice) =>
    (voice.lang || "").toLowerCase().startsWith("pt-br")
  );
  return brazilian || portugueseVoices[0];
}
